import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { EuiFormLabel, EuiComboBox, EuiComboBoxOptionOption, EuiFlexGroup } from '@elastic/eui';
import { MODEL_NAMES } from 'apollo-client/queries/getAvailableModelNames';
import { modelNames } from 'cache';
import { Query, QueryGetAvailableModelNamesArgs } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { FormattedMessage, useIntl } from 'react-intl';
import { SelectAll } from 'components/SelectAll';

import * as S from './FiltersSidebar.styles';

export const ModelNamesFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();
  const [selectAll, setSelectAll] = useState(false);

  const [onGetAvailableModelNames, { loading, data }] = useLazyQuery<Query, QueryGetAvailableModelNamesArgs>(
    MODEL_NAMES,
    {
      fetchPolicy: 'network-only',
    }
  );

  return (
    <S.SidebarFilterWrapper>
      <EuiFlexGroup justifyContent="spaceBetween">
        <EuiFormLabel>{formatMessage({ id: 'filters.modelNames.label' })}</EuiFormLabel>
        {selectAll && (
          <SelectAll
            onClick={(): void => {
              modelNames(data?.getAvailableModelNames);
              setSelectAll(false);
            }}
          >
            <FormattedMessage id="filters.selectAll" defaultMessage="Seleziona Tutti" />
          </SelectAll>
        )}
      </EuiFlexGroup>
      <EuiComboBox
        async
        isLoading={loading}
        placeholder={formatMessage({ id: 'filters.modelNames.placeholder' })}
        options={data?.getAvailableModelNames?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={localFilters?.data?.modelNames?.map((x: string) => ({
          label: x,
          value: x,
        }))}
        onSearchChange={(e: string): void => {
          e.length > 2 ? setSelectAll(true) : setSelectAll(false);
          onGetAvailableModelNames({
            variables: {
              inputModelName: e,
              inputBrandNames: localFilters?.data?.brandNames,
              inputVehicleYears: localFilters?.data?.modelYear?.length ? localFilters?.data?.modelYear : undefined,
            },
          });
        }}
        onClick={(): void => {
          onGetAvailableModelNames({
            variables: {
              inputModelName: null,
              inputBrandNames: localFilters?.data?.brandNames?.length ? localFilters?.data?.brandNames : undefined,
              inputVehicleYears: localFilters?.data?.modelYear?.length ? localFilters?.data?.modelYear : undefined,
            },
          });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): void => {
          modelNames(x?.map(({ value }) => value) as string[]);
        }}
      />
    </S.SidebarFilterWrapper>
  );
};
